import { render } from "./StocksList.vue?vue&type=template&id=2baf8987&scoped=true"
import script from "./StocksList.vue?vue&type=script&lang=js"
export * from "./StocksList.vue?vue&type=script&lang=js"

import "./StocksList.vue?vue&type=style&index=0&id=2baf8987&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2baf8987"]])

export default __exports__